import Vue from "vue";
import Router from "vue-router";
import store from "@/redworks/stores/index";
import { RX_PAGE } from "@/redworks/js/consts/rx-const";
import { $checkAuth, $checkUsePlcAuth } from "@/redworks/api/auth";
// import { RX_PAGE } from "@/redworks/js/consts/rx-const";

Vue.use(Router);

/* url목록 */
const routes = [
  // console창에 warning - Duplicate named routes definition: { name: "404", path: "*" }
  // {
  //   path: RX_PAGE.NOT_FOUND_PAGE,
  //   name: "404",
  //   component: () => import("@/redworks/views/auth/NotFoundPage.vue"),
  // },
  {
    path: "*",
    name: "404",
    component: () => import("@/redworks/views/auth/NotFoundPage.vue"),
  },
  {
    path: RX_PAGE.LOGIN,
    name: "Login",
    beforeEnter: isSigned,
    component: () => import("@/redworks/views/auth/Login.vue"),
    meta: {
      title: "login.lbl.login",
    },
  },
  {
    path: RX_PAGE.HOME,
    name: "Home",
    beforeEnter: checkAuth,
    component: () => import("@/redcrm/views/coupon/CouponList.vue"),
    meta: {
      title: "coupon.lbl.coupon",
      groupId: "COUPON"
    },
  },
];

/* 인증체크  */
async function checkAuth(_to, from, next) {
  if (
    undefined !== store.getters["auth/getAccessToken"] &&
    store.getters["auth/getAccessToken"] !== null
  ) {
    try {
      const { data } = store.getters["auth/getUseplcCode"] !== null ? await $checkUsePlcAuth() : await $checkAuth();
      //const { data } = await $checkAuth();
      if (data.status === 200) {
        //다음 화면으로 이동.
        next();
      }
    } catch (error) {
      if (from.path !== RX_PAGE.LOGIN) {
        store.dispatch("auth/initAuthorization");
        next({ name: "Login", params: { path: _to.path } });
      }
    }
  } else {
    // 인증정보 초기화
    store.dispatch("auth/initAuthorization");
    next({ name: "Login", params: { path: _to.path } });
  }
}

/* 로그인페이지 체크  */
async function isSigned(_to, _from, next) {
  const token = store.getters["auth/getAccessToken"];
  if (undefined === token || token === null || token === "") {
    // 1. 인증정보가 없을 경우 Login 페이지로
    next();
  } else {
    // 2. 인증정보 검증
    try {
      //const { data } = await $checkAuth();
      const { data } = store.getters["auth/getUseplcCode"] !== null ? await $checkUsePlcAuth() : await $checkAuth();
      // 2_1. 인증검증 성공 시,
      if (data.status === 200) {
        // 3. 비밀번호 인증정책 확인 (새로고침 대비)
        const expiredPolicy = store.getters["auth/getExpiredPolicy"];
        if (
          // 3_1_1. (경우1)초기화 비밀번호 필수 변경 정책 TRUE / 사용자의 비밀번호 변경 TRUE
          (store.getters["auth/getEnforceInitPasswordChange"] &&
            store.getters["auth/getIsChangedInitPwd"]) ||
          // 3_1_2. (경우2)비밀번호 변경기간 사용 TRUE & 변경기간이 지남 & 비밀번호 변경 필수 TRUE
          (expiredPolicy.usable &&
            isOverExpiredIn(
              new Date(),
              new Date(store.getters["auth/getPasswordChagedAt"]),
              expiredPolicy.passwordExpiresIn
            ) &&
            expiredPolicy.enforcePasswordChange)
        ) {
          // 3_1. 비밀번호 인증정책에 걸리면 로그인 페이지의 Stepper=2
          next();
        } else {
          // 3_2. 비밀번호 인증정책에 걸리지 않으면 메인 화면
          next(RX_PAGE.HOME);
        }
      } else {
        // 2_2. 인증검증 실패 시, 인증정보 초기화
        store.dispatch("auth/initAuthorization");
        next();
      }
    } catch (e) {
      store.dispatch("auth/initAuthorization");
      next();
    }
  }
}

function isOverExpiredIn(today, passwordChangedAt, passwordExpiredIn) {
  let diff = Math.abs(today.getTime() - passwordChangedAt.getTime());
  diff = Math.ceil(diff / (1000 * 3600 * 24)) - 1;
  return diff >= passwordExpiredIn;
}

/* 다른 route 정보를 MAIN의 children에 추가 */
function addRoute() {
  // 1. routes 폴더 내의 route(.js) 파일 모두 가져옴
  const route = require.context("@", true, /routes\/[A-Za-z0-9-_,\s]+\.js$/i);

  route.keys().forEach((key) => {
    const split = key.split('/');
    if(split && split.length > 2 && split[1] != 'redworks' && split[3] == 'index.js') {
      routes.push(...route(key).default);
    }
  });

  return routes;
}

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: addRoute(),
});

router.beforeEach((to, from, next) => {
  // 라우터 메타 정보의 checkAuth = true 이면 권한 체크 메소드 실행
  store.dispatch("app/setSpinner", { isLoading: false }); // 스토어에 로딩 진행 중인 경우 메뉴 이동 시 강제 변경
  store.dispatch("app/clearPrevFilter", to.meta.groupId);

  if (undefined != to.meta.checkAuth && true == to.meta.checkAuth) {
    checkAuth(to, from, next);
  } else {
    next();
  }
});



export default router;
